import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const monitorsApi = {
    getMonitors: (): Observable<Dtos.GetMonitorsResponse> => {
        //Create the request.
        let request: Dtos.GetMonitors = new Dtos.GetMonitors();

        //Send request.
        const response: Promise<Dtos.GetMonitorsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getMonitorsByMonitoringId: (monitoringId: number): Observable<Dtos.GetMonitorsByMonitoringIdResponse> => {
        //Create the request.
        let request: Dtos.GetMonitorsByMonitoringId = new Dtos.GetMonitorsByMonitoringId();

        request.monitoringId = monitoringId;

        //Send request.
        const response: Promise<Dtos.GetMonitorsByMonitoringIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getMonitorById: (id: number): Observable<Dtos.GetMonitorByIdResponse> => {
        //Create the request.
        let request: Dtos.GetMonitorById = new Dtos.GetMonitorById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetMonitorByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setMonitor: (monitor: Dtos.Monitor): Observable<Dtos.SetMonitorResponse> => {

        let request: Dtos.SetMonitor = new Dtos.SetMonitor();

        request.monitor = monitor;

        // send request
        const response: Promise<Dtos.SetMonitorResponse> = client.post(request);

        return Observable.from(response);
    },
    createMonitor: (monitoringId: number): Observable<Dtos.CreateMonitorResponse> => {
        //Create the request.
        let request: Dtos.CreateMonitor = new Dtos.CreateMonitor();

        request.monitoringId = monitoringId;

        //Send request.
        const response: Promise<Dtos.CreateMonitorResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateMonitor: (monitor: Dtos.Monitor): Observable<Dtos.ValidateMonitorResponse> => {

        let request: Dtos.ValidateMonitor = new Dtos.ValidateMonitor();

        request.monitor = monitor;

        // send request
        const response: Promise<Dtos.ValidateMonitorResponse> = client.post(request);

        return Observable.from(response);
    }
}